/**
 * ProcessSteps — how a matter runs at the firm, five stages.
 * Rendered as an ordered list so assistive tech and AI crawlers read the
 * sequence correctly; HowTo JSON-LD is emitted by the route, not here.
 */
export interface FirmStep {
  title: string;
  body: string;
}

export const FIRM_STEPS: FirmStep[] = [
  {
    title: "ประเมินเรื่องเบื้องต้น",
    body: "ส่งเอกสารหรือเล่าเรื่องมาทางโทรศัพท์ LINE หรืออีเมล ทีมงานตรวจว่าเรื่องอยู่ในสายงานใด ต้องใช้เอกสารอะไร และมีกำหนดเวลาตามกฎหมายที่ต้องระวังหรือไม่",
  },
  {
    title: "เสนอแนวทางและค่าบริการเป็นลายลักษณ์อักษร",
    body: "ทนายผู้รับผิดชอบสรุปทางเลือก ข้อจำกัด ความเสี่ยง ระยะเวลาที่ประเมินได้ และค่าบริการเป็นเอกสารก่อนเริ่มงาน ค่าธรรมเนียมราชการเรียกเก็บตามอัตราของหน่วยงานตามจริง",
  },
  {
    title: "ตั้งเรื่องและเตรียมเอกสาร",
    body: "ลงนามใบแต่งทนายหรือหนังสือมอบอำนาจตามลักษณะงาน ทีมงานจัดชุดเอกสาร แปลและรับรองเมื่อจำเป็น และตรวจการสะกดชื่อให้ตรงกับเอกสารทางการ",
  },
  {
    title: "ดำเนินการแทนท่าน",
    body: "ยื่นเอกสารต่อศาลหรือหน่วยงาน ว่าความ เจรจา หรือเดินเรื่องรับรองเอกสารตามลำดับที่ปลายทางกำหนด ท่านเข้ามาเฉพาะขั้นที่กฎหมายกำหนดให้ตัวความมาเอง",
  },
  {
    title: "รายงานผลและติดตามต่อ",
    body: "แจ้งผลทุกขั้นสำคัญ ส่งมอบเอกสารพร้อมสำเนาชุดอ้างอิง และแจ้งเตือนกำหนดเวลาที่ต้องทำต่อ เช่น วันนัดศาล วันต่ออายุ หรือวันครบกำหนดยื่นเอกสาร",
  },
];

export function ProcessSteps() {
  return (
    <section aria-labelledby="firm-process" className="border-b border-border/60 bg-muted/40">
      <div className="mx-auto max-w-5xl px-6 py-16">
        <p className="text-xs font-semibold uppercase tracking-[0.24em] text-[var(--gold)]">
          ขั้นตอนการทำงาน
        </p>
        <h2 id="firm-process" className="mt-2 text-3xl font-bold tracking-tight text-foreground md:text-4xl">
          ทำงานกับสำนักงานของเราอย่างไร
        </h2>
        <ol className="mt-10 space-y-4">
          {FIRM_STEPS.map((s, i) => (
            <li key={s.title} className="flex gap-4 rounded-xl border border-border bg-card p-6">
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[var(--primary)] text-sm font-bold text-[var(--gold)]">
                {i + 1}
              </span>
              <div>
                <h3 className="text-base font-semibold text-foreground">{s.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{s.body}</p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
